import type { ReactNode } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

export interface TabLink {
	label: string;
	to: string;
	icon?: ReactNode;
	disabled?: boolean;
}

interface RoutedTabsProps {
	tabs: TabLink[];
}

export const RoutedTabs = ({ tabs }: RoutedTabsProps) => (
	<>
		<div className="flex flex-col overflow-auto md:overflow-visible w-full">
			<div className="flex space-x-space-8" role="tablist">
				{tabs.map((tab) =>
					tab.disabled ? (
						<span
							key={tab.to}
							className="text-sm-medium py-space-6 pl-space-16 pr-space-12 rounded-lg flex items-center gap-space-8 whitespace-nowrap bg-neutral-100 text-neutral-400"
						>
							{tab.label}
							{tab.icon}
						</span>
					) : (
						<NavLink
							key={tab.to}
							className={({ isActive }) =>
								`text-sm-medium py-space-6 pl-space-16 pr-space-12 rounded-lg flex items-center gap-space-8 whitespace-nowrap ${
									isActive
										? 'bg-neutral-950 text-neutral-white'
										: 'bg-neutral-50 hover:bg-neutral-100 hover:cursor-pointer text-neutral-950'
								}`
							}
							replace
							role="tab"
							to={tab.to}
						>
							{tab.label}
							{tab.icon}
						</NavLink>
					),
				)}
			</div>
		</div>
		<Outlet />
	</>
);
